// ExpensesSettings.js




import React, {useEffect, useState} from 'react';
import {
    Card,
    Table,
    Button,
    Space,
    Modal,
    Form,
    Input,
    ColorPicker,
    Tag,
    Divider,
    Popconfirm,
    message, Spin
} from 'antd';
import {
    EditOutlined,
    DeleteOutlined,
    PlusOutlined, LoadingOutlined
} from '@ant-design/icons';

import style from '../styles/expenses.settings.module.css';
import {instance} from "../../../API/API";
export const expenseCategoriesApi = {
    // Получить все категории
    getAll: async () => {
        const response = await instance.get('/finance_04122025/expense_categories.php');
        return response.data;
    },

    // Создать категорию
    create: async (categoryData) => {
        const response = await instance.post('/finance_04122025/expense_categories.php', categoryData);
        return response.data;
    },

    // Обновить категорию
    update: async (id, categoryData) => {
        const response = await instance.put('/finance_04122025/expense_categories.php', {
            id,
            ...categoryData
        });
        return response.data;
    },

    // Удалить категорию
    delete: async (id) => {
        const response = await instance.delete(`/finance_04122025/expense_categories.php?id=${id}`);
        return response.data;
    }
};

const ExpensesSettings = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingCategory, setEditingCategory] = useState(null);
    const [form] = Form.useForm();

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            const response = await expenseCategoriesApi.getAll();
            if (response.success) {
                setCategories(response.data);
            }
        } catch (error) {
            message.error('Ошибка при загрузке категорий');
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = () => {
        setEditingCategory(null);
        form.resetFields();
        form.setFieldsValue({ color: '#1677ff' });
        setIsModalOpen(true);
    };

    const handleEdit = (category) => {
        setEditingCategory(category);
        form.setFieldsValue({
            name: category.name,
            description: category.description,
            color: category.color
        });
        setIsModalOpen(true);
    };

    const handleDelete = async (id) => {
        try {
            setLoading(true)
            const response = await expenseCategoriesApi.delete(id);
            if (response.success) {
                setCategories(categories.filter(cat => cat.id !== id));
                message.success('Категория удалена');
            }
        } catch (error) {
            message.error('Ошибка при удалении категории');
        } finally {
            setLoading(false)
        }
    };

    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            if (editingCategory) {
                const response = await expenseCategoriesApi.update(editingCategory.id, values);
                if (response.success) {
                    setCategories(categories.map(cat =>
                        cat.id === editingCategory.id
                            ? { ...cat, ...values }
                            : cat
                    ));
                    message.success('Категория обновлена');
                }
            } else {
                const response = await expenseCategoriesApi.create(values);
                if (response.success) {
                    setCategories([...categories, response.data]);
                    message.success('Категория добавлена');
                }
            }

            setIsModalOpen(false);
            form.resetFields();
        } catch (error) {
            console.error('Error saving category:', error);
        }
    };

    const columns = [
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <Space>
                    <div
                        className={style.colorDot}
                        style={{ backgroundColor: record.color }}
                    />
                    {text}
                </Space>
            )
        },
        {
            title: 'Описание',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Цвет',
            dataIndex: 'color',
            key: 'color',
            render: (color) => <Tag color={color}>{color}</Tag>
        },
        {
            title: 'Действия',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button
                        type="text"
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record)}
                    />
                    <Popconfirm
                        title="Удалить категорию?"
                        onConfirm={() => handleDelete(record.id)}
                    >
                        <Button
                            type="text"
                            danger
                            icon={<DeleteOutlined />}
                        />
                    </Popconfirm>
                </Space>
            )
        }
    ];

    if (loading) {
        return (
            <div className={style.container}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
            </div>
        );
    }

    return (
        <div className={style.container}>
            <Divider style={{ borderColor: '#7cb305' }}>Настройки расходов</Divider>

            <Card
                title="Категории расходов"
                extra={
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleAdd}
                    >
                        Добавить категорию
                    </Button>
                }
            >
                <Table
                    columns={columns}
                    dataSource={categories}
                    rowKey="id"
                    size={'small'}
                    pagination={false}
                />
            </Card>

            <Modal
                title={editingCategory ? "Редактировать категорию" : "Добавить категорию"}
                open={isModalOpen}
                onOk={handleSave}
                onCancel={() => {
                    setIsModalOpen(false);
                    form.resetFields();
                }}
                okText="Сохранить"
                cancelText="Отмена"
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="name"
                        label="Название"
                        rules={[{ required: true, message: 'Введите название' }]}
                    >
                        <Input placeholder="Например: Аренда" />
                    </Form.Item>

                    <Form.Item
                        name="description"
                        label="Описание"
                    >
                        <Input.TextArea
                            placeholder="Описание категории"
                            rows={3}
                        />
                    </Form.Item>

                    <Form.Item
                        name="color"
                        label="Цвет"
                        rules={[{ required: true, message: 'Выберите цвет' }]}
                        getValueFromEvent={(color) => color.toHexString()}
                    >
                        <ColorPicker
                            format="hex"
                            showText
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default ExpensesSettings;